import React from 'react';

// MUI
import { Button, Grid } from '@mui/material';
import {
  MoreHoriz,
  Link,
  Preview,
  TableRows,
  Code,
  FormatPaint,
  Settings,
} from '@mui/icons-material';

function FormAdditionalButtons(props) {
  const { templateLoading } = props;
  return (
    <>
      <Grid item>
        <Button variant="text"
          size={'small'}
          startIcon={<MoreHoriz />}
          onClick={props.handleSettings}
          disabled={templateLoading}
        >
          Form settings
        </Button>
      </Grid>
      <Grid item>
        <Button variant="text"
          size={'small'}
          startIcon={<Preview />}
          onClick={props.handlePreview}
          disabled={templateLoading}
        >
          Preview
        </Button>
      </Grid>
      {props.isForm && (
        <Grid item>
          <Button variant="text"
            size={'small'}
            startIcon={<Link />}
            onClick={props.handleLink}
            disabled={templateLoading}
          >
            Link
          </Button>
        </Grid>
      )}
      <Grid item>
        <Button variant="text"
          size={'small'}
          startIcon={<TableRows />}
          onClick={props.handleData}
          disabled={templateLoading}
        >
          Submission data
        </Button>
      </Grid>
      {props.isForm && (
        <Grid item>
          <Button variant="text"
            size={'small'}
            startIcon={<Code />}
            onClick={props.handleEmbed}
            disabled={templateLoading}
          >
            Embed
          </Button>
        </Grid>
      )}
      <Grid item>
        <Button variant="text"
          size={'small'}
          startIcon={<Settings />}
          onClick={props.handleFormSettings}
          disabled={templateLoading}
        >
          Settings
        </Button>
      </Grid>
      <Grid item>
        <Button variant="text"
          size={'small'}
          startIcon={<FormatPaint />}
          onClick={props.handleStyling}
          disabled={templateLoading}
        >
          Styling
        </Button>
      </Grid>
    </>
  );
}

export default FormAdditionalButtons;
